function footerController($scope, coreService) {
    activate();

    function activate() {
        // Read Identity Server's data model into scope
        $scope.model = coreService.getIdentityModel();

       //get today and use it in the footer copyright section
       $scope.date = new Date();
       $scope.selectedLanguage = {
        code: '',
        productLanguageId: ''
      };
  
      var model = coreService.getIdentityModel();
      if (model && model.custom) {
        $scope.baseUri = model.custom.api_base;
        $scope.selectedLanguage.productLanguageId = model.custom.language;
        $scope.selectedLanguage.code = model.custom.ui_locales;
      }
      else {
        $scope.selectedLanguage.code = model.ui_locales;
      }
    }
}

export default footerController;



// WEBPACK FOOTER //
// ./src/login/footer/footer.controller.js